var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spacing flex xs12 md12"},[_c('va-card',{attrs:{"title":"Spacing"}},[_c('spacing-playgroud',{attrs:{"title":''}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }